import React from "react";
import { FormInputType } from "../Forms";

function rowInput(input, props) {
  if (Array.isArray(input)) {
    return <div class="row row-sm">
      {input.map((input) => {
        return <div class="col-xs-4">
          <FormInputType
            {...input}
            onChange={props.onChange}
            uploadFile={props.uploadFile}
            downloadFile={props.downloadFile} />
        </div>
      })}
    </div>
  } else {
    return <FormInputType
      {...input}
      onChange={props.onChange}
      uploadFile={props.uploadFile}
      downloadFile={props.downloadFile} />
  }
}

export const Form = props =>
  <div className="content-item">
    <div className="content-overflown">
      <div className="container-xs">
        <form name="form-template" onSubmit={props.handleSubmit}>
          <div className="box pad-md">
            {props.title ? <h2 className="box-title">{props.title}</h2> : null}
            {props.inputs.map((input, index) =>
              <div className="form-col">
                {rowInput(input, props)}
              </div>)}
          </div>
          {props.buttons ? <div className="box-actions-footer">
            {props.buttons.map(Button => Button)}
          </div> : null}
        </form>
        <div className="box-actions-footer">{props.outform ? props.outform : null}</div>
      </div>
    </div>
  </div>
